export const PARTNER_LINK_VISITED = 'partner_link_visited';
export const REDIRECT_TO_NAMMERT_PLATFORM = 'redirect-to-nammert-platform';
export const EXTERNAL_CALCULATOR_CALCULATED_OFFER = 'external-calculator-calculated-offer';
export const LOCAL_CALCULATOR_CALCULATED_OFFER = 'local-calculator-calculated-offer';
export const NEW_CONTRACT_THROUGH_PARTNER = 'new-contract-through-partner';
